import React from "react";
import DatePicker from "../../../datePicker/DatePicker";
import DropdownSelect from "../../../dropdown/Dropdown";
import Validation from "../../../../utils/validation/ValidationText";
import moment from "moment";
import TextInput from "../../../UIComponent/TextInput";
import ButtonLoader from "../../../common/buttonLoader/ButtonLoader";

function CorporateMembershipSubscription(props) {
  return (
    <div>
      <div className="2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 lg:py-7 lg:pt-5">
        <div className="grid grid-cols-12 gap-6 w-full ">
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Membership Type
                  <span className="text-[#c00000]"></span>
                </h2>

                <DropdownSelect
                  drpIdentity={"MembershipTypesSubscription"}
                  optionArray={props.membershipTypes}
                  setFilterParameters={props.setFilterParameters}
                  value={props.membershipSubscription.membershipTypeId}
                  disabled={props.membershipSubscription.isAdminLogged}
                  // onBlur={(e) => props.validate("membershipTypeId", props.membershipSubscription)}
                />
                {/* <Validation error={props.validState.error.membershipTypeId} /> */}
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Billing Category
                  <span className="text-[#c00000]"></span>
                </h2>

                <DropdownSelect
                  drpIdentity={"corporateMemberBillingCategoryId"}
                  optionArray={props.billingCategory}
                  setFilterParameters={props.setFilterParameters}
                  value={props.membershipSubscription.billingCategoryId}
                  // onBlur={(e) => props.validate("corporateMemberBillingCategoryId", props.membershipSubscription)}
                  disabled={true}
                />
                {/* <Validation error={props.validState.error.corporateMemberBillingCategoryId} /> */}
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Subscription Start Date
                  {/* <span className="text-[#c00000]">*</span> */}
                </h2>
                <div
                  className={`dropdwn-input-email flex items-center ${
                    !props.membershipSubscription.isAdminLogged
                      ? "disabled-input"
                      : ""
                  }`}
                >
                  <DatePicker
                    // isDisable ={props.membershipSubscription.isDisabledDates ? true  : false}
                    isDisable={!props.membershipSubscription.isAdminLogged}
                    name="subscriptionStartDate"
                    handleChange={props.handleChange}
                    identity="MembershipSubscription"
                    value={moment(
                      props.membershipSubscription.subscriptionStartDate
                    ).format("yyyy-MM-DD")}
                    // onBlur={(e) => props.validate("corporateJoinedDate", props.membershipSubscription)}
                  />

                  {/* <Validation error={props.validState.error.subscriptionStartDate} /> */}
                </div>
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Subscription End Date
                  {/* <span className="text-[#c00000]">*</span> */}
                </h2>
                <div
                  className={`dropdwn-input-email flex items-center`}
                >
                  <DatePicker
                    //isDisable={!props.membershipSubscription.isAdminLogged}
                    name="subcriptionEndDate"
                    handleChange={props.handleChange}
                    identity="MembershipSubscription"
                    value={moment(
                      props.membershipSubscription.subcriptionEndDate
                    ).format("yyyy-MM-DD")}
                    // onBlur={(e) => props.validate("corporateJoinedDate", props.membershipSubscription)}
                  />

                  {/* <Validation error={props.validState.error.subcriptionEndDate} /> */}
                </div>
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Incorporation Date (Based on ACRA)
                  {/* <span className="text-[#c00000]">*</span> */}
                </h2>
                <div className="disabled-input dropdwn-input-email flex items-center">
                  <DatePicker
                    isDisable={true}
                    name="subcriptionEndDate"
                    handleChange={props.handleChange}
                    identity="commencementDate"
                    value={moment(
                      props.membershipSubscription.incorporationDate
                    ).format("yyyy-MM-DD")}
                    // onBlur={(e) => props.validate("corporateJoinedDate", props.membershipSubscription)}
                  />

                  {/* <Validation error={props.validState.error.subcriptionEndDate} /> */}
                </div>
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl theme-color font-bold 2xl:mb-1">
                  Updated By
                </h2>
                <DropdownSelect
                  disabled={true}
                  drpIdentity={"updatedById"}
                  optionArray={props._by}
                  setFilterParameters={props.setFilterParameters}
                  value={props.membershipSubscription.updatedBy}
                  // onBlur={(e) => props.validate("updatedById", props.membershipSubscription)}
                />
                {/* <Validation error={props.validState.error.updatedById} /> */}
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Last Updated Date
                  {/* <span className="text-[#c00000]">*</span> */}
                </h2>
                <div className="disabled-input">
                  {props.membershipSubscription.updatedAt === "" ||
                  props.membershipSubscription.updatedAt === null ? (
                    <TextInput
                      disabled={true}
                      placeholder=""
                      type="text"
                      name="linkedIn"
                      value="None"
                      identity="BasicInformation"
                    />
                  ) : (
                    <DatePicker
                      isDisable={true}
                      name="updatedAt"
                      handleChange={props.handleChange}
                      identity="updatedAt"
                      value={moment(
                        props.membershipSubscription.updatedAt
                      ).format("yyyy-MM-DD")}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="xl:col-span-12 md:col-span-12 col-span-12">
                <label
                  className="text-xl text-[#757575] font-bold 2xl:mb-1"
                  htmlFor="default"
                >
                  Billing Entity <span className="text-[#C00000]">*</span>
                </label>
                <input
                  id="default"
                  className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                  type="text"
                  name="billingEntity"
                  value={props.membershipSubscription.billingEntity ?? ""}
                  onChange={(e) =>
                    props.handleChange(e, "MembershipSubscription")
                  }
                  identity="MembershipSubscription"

                  // validateField={() => props.validateField("organisationUEN")}
                />
                <div>
                  {/* <ValidationText error={props.validState.error.organisationUEN} /> */}
                </div>
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="xl:col-span-12 md:col-span-12 col-span-12">
                <label
                  className="text-xl text-[#757575] font-bold 2xl:mb-1"
                  htmlFor="default"
                >
                  Billing Attention <span className="text-[#C00000]">*</span>
                </label>
                <div className="flex">
                  <div className="w-[130px]">
                    <DropdownSelect
                      drpIdentity={"AttentionSalutation"}
                      optionArray={props.mrMrs}
                      setFilterParameters={props.setFilterParameters}
                      value={props.membershipSubscription.attentionSalutationId}
                    />
                  </div>
                  <input
                    id="default"
                    className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                    type="text"
                    name="billingAttention"
                    value={props.membershipSubscription.billingAttention ?? ""}
                    onChange={(e) =>
                      props.handleChange(e, "MembershipSubscription")
                    }
                    identity="MembershipSubscription"

                    // validateField={() => props.validateField("organisationUEN")}
                  />
                </div>
                {/* <ValidationText error={props.validState.error.organisationName} /> */}
              </div>
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="xl:col-span-12 md:col-span-12 col-span-12">
                <label
                  className="text-xl text-[#757575] font-bold 2xl:mb-1"
                  htmlFor="default"
                >
                  Billing Email Address{" "}
                  <span className="text-[#C00000]">*</span>
                </label>
                <input
                  id="default"
                  className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                  type="text"
                  name="billingEmailAddress"
                  value={props.membershipSubscription.billingEmailAddress}
                  onChange={(e) =>
                    props.handleChange(e, "MembershipSubscription")
                  }
                  identity="MembershipSubscription"

                  // validateField={() => props.validateField("organisationName")}
                />
                {/* <ValidationText error={props.validState.error.organisationName} /> */}
              </div>
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl theme-color font-bold 2xl:mb-1">
                  Billing Country
                </h2>
                <DropdownSelect
                  drpIdentity={"Countries"}
                  optionArray={props.CountriesforCMS}
                  setFilterParameters={props.setFilterParameters}
                  value={props.membershipSubscription.billingCountyId}
                  // onBlur={(e) => props.validate("updatedById", props.membershipSubscription)}
                />
                {/* <Validation error={props.validState.error.updatedById} /> */}
              </div>
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="xl:col-span-12 md:col-span-12 col-span-12">
                <label
                  className="text-xl text-[#757575] font-bold 2xl:mb-1"
                  htmlFor="default"
                >
                  Billing Address <span className="text-[#C00000]">*</span>
                </label>
                <input
                  id="default"
                  className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                  type="text"
                  name="billingAddress"
                  value={props.membershipSubscription.billingAddress}
                  onChange={(e) =>
                    props.handleChange(e, "MembershipSubscription")
                  }
                  identity="MembershipSubscription"

                  // validateField={() => props.validateField("organisationName")}
                />
                {/* <ValidationText error={props.validState.error.organisationName} /> */}
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="xl:col-span-12 md:col-span-12 col-span-12">
                <label
                  className="text-xl text-[#757575] font-bold 2xl:mb-1"
                  htmlFor="default"
                >
                  Billing Postal Code <span className="text-[#C00000]">*</span>
                </label>
                <input
                  id="default"
                  className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                  type="text"
                  name="billingPostalCode"
                  value={props.membershipSubscription.billingPostalCode}
                  onChange={(e) =>
                    props.handleChange(e, "MembershipSubscription")
                  }
                  identity="MembershipSubscription"

                  // validateField={() => props.validateField("organisationName")}
                />
                {/* <ValidationText error={props.validState.error.organisationName} /> */}
              </div>
            </div>
          </div>
          {/* <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                 Renewal Approval Date
                  <span className="text-[#c00000]">*</span>
                </h2>
                <div className="disabled-input dropdwn-input-email flex items-center">
                  <DatePicker
                    isDisable={true}
                    name="approvalDate"
                    handleChange={props.handleChange}
                    identity="MembershipSubscription"
                    value={moment(props.membershipSubscription.approvalDate).format("yyyy-MM-DD")}
                  onBlur={(e) => props.validate("corporateJoinedDate", props.membershipSubscription)}
                  />

                  <Validation error={props.validState.error.subcriptionEndDate} />
                </div>
              </div>
            </div>
          </div> */}
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts mt-auto">
            <div className="flex items-center justify-between">
              <div className="grid grid-cols-8 gap-6">
                <div className="col-span-8 flex items-center gap-[10px] w-full">
                  <input
                    id=""
                    name="resignationFlag"
                    type="checkbox"
                    className="cursor-pointer h-4 w-4 text-[#f93549] focus:ring-[#f93549] rounded check-box-custom"
                    value={
                      props.membershipSubscription.resignationFlag
                        ? props.membershipSubscription.resignationFlag
                        : false
                    }
                    // disabled={true}
                    onChange={(e) =>
                      props.handleChangeCheckBoxforcorporateSubscription(e)
                    }
                    checked={
                      props.membershipSubscription.resignationFlag
                        ? props.membershipSubscription.resignationFlag
                        : false
                    }
                  />
                  <label
                    htmlFor="isRequireQuotation"
                    className="text-xl text-[#757575] font-bold 2xl:mb-1"
                  >
                    Pend Invoice
                  </label>
                </div>
              </div>
              <div className="flex space-x-4 grid-col-4">
                {/* Uncomment if needed:
              <button
                className="w-132 px-7 py-3 btn-sm btn-red text-xl text-white font-semibold h-[50px]"
                onClick={(e) => {
                  e.stopPropagation();
                  props.handleClick();
                }}
              >
                Super Login
              </button>
              */}

                {props.membershipSubscription.statusId === 4 &&
                  !props.membershipSubscription.isAdminLogged && (
                    <button
                      className="w-132 px-7 py-3 btn-sm btn-red text-xl text-white font-semibold h-[50px]"
                      onClick={(e) => {
                        e.stopPropagation();
                        props.handleClickForLogin();
                      }}
                    >
                      Login
                    </button>
                  )}

                <div className="flex items-center justify-end">
                  {props.isMembershipSubscriptionLoading ? (
                    <ButtonLoader className="buttonload group relative rounded-md btn btn-red text-xl text-white focus:outline-none" />
                  ) : props.membershipSubscription.isAdminLogged ? (
                    <button
                      className="w-34 px-7 py-3 btn-sm btn-red text-xl text-white font-semibold"
                      onClick={() =>
                        props.updateSubscriptionDatesForActiveCMemberById()
                      }
                    >
                      Adjust Term
                    </button>
                  ) : (
                    <button
                      className="w-32 px-7 py-3 btn-sm btn-red text-xl text-white font-semibold"
                      onClick={() => props.onSave()}
                    >
                      Save
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Membership Status
                  <span className="text-[#c00000]"></span>
                </h2>
                <TextInput
                  type="text"
                  name="MembershipStatus"
                  value={props.membershipSubscription.membershipStatusName}
                  identity="membershipSubscription"
                  handleChange={props.handleChange}
                  className={"bg-[#e9e9ea]  text-gray-500 cursor-not-allowed"}
                />
                {/* <Validation error={props.validState.error.membershipTypeId} /> */}
              </div>
            </div>
          </div>

          {props.membershipSubscription.membershipStatusName === "Active" ? (
            // ---------- Deactivate flow ----------
            <>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts mt-auto">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-8 flex items-center gap-[10px] w-full">
                    <input
                      name="deactiveMemberFlag"
                      type="checkbox"
                      className="cursor-pointer h-4 w-4 text-[#f93549] focus:ring-[#f93549] rounded check-box-custom"
                      onChange={(e) =>
                        props.handleChangeCheckBoxforcorporateSubscription(e)
                      }
                      checked={props.membershipSubscription.deactiveMemberFlag}
                    />
                    <label
                      htmlFor="deactiveMemberFlag"
                      className="text-xl text-[#757575] font-bold 2xl:mb-1"
                    >
                      Deactivate
                    </label>
                  </div>
                </div>
              </div>

              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">Comments</h2>
                    <TextInput
                      type="text"
                      name="Comments"
                      disabled={!props.membershipSubscription.deactiveMemberFlag}
                      value={props.membershipSubscription.comments}
                      identity="membershipSubscription"
                      handleChange={props.handleChange}
                      className={`${!props.membershipSubscription.deactiveMemberFlag
                        ? "bg-[#e9e9ea]  text-gray-500 cursor-not-allowed"
                        : ""
                        }`}
                    />
                  </div>
                </div>
              </div>

              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6 mt-10">
                  <div className="xl:col-span-12 lg:col-span-12 col-span-12 new-btn">
                    {props.membershipSubscription.deactiveMemberFlag ? (
                      <button
                        className="w-32 px-7 py-3 btn-sm btn-red text-xl text-white font-semibold"
                        onClick={() => props.deactivateCorporateMember()}
                      >
                        Save
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            </>
          ) : (
            // ---------- Activate flow ----------
            <>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts mt-auto">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-8 flex items-center gap-[10px] w-full">
                    <input
                      name="activeMemberFlag"
                      type="checkbox"
                      className="cursor-pointer h-4 w-4 text-green-600 focus:ring-green-600 rounded check-box-custom"
                      onChange={(e) =>
                        props.handleChangeCheckBoxforcorporateSubscription(e)
                      }
                      checked={props.membershipSubscription.activeMemberFlag}
                    />
                    <label
                      htmlFor="activeMemberFlag"
                      className="text-xl text-[#757575] font-bold 2xl:mb-1"
                    >
                      Active
                    </label>
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6 mt-10">
                  <div className="xl:col-span-12 lg:col-span-12 col-span-12 new-btn">
                    {props.membershipSubscription.activeMemberFlag ? (
                      <button
                        className="w-32 px-7 py-3 btn-sm btn-red text-xl text-white font-semibold"
                        onClick={() => props.deactivateCorporateMember()}
                      >
                        Save
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Renew Button */}
        <div className="grid grid-cols-12 gap-6 mt-10">
          <div className="xl:col-span-12 lg:col-span-12 col-span-12 new-btn">
            {/* {props.membershipSubscription.billingCategoryId !== 1 && props.membershipSubscription.billingCategoryId !== 7 && props.membershipSubscription.billingCategoryId !== 4
              && props.membershipSubscription.subcriptionEndDate !== null && props.membershipSubscription.subcriptionEndDate !== "" ?
              <div className="left-btn">
                <a href="#."
                  className="flex items-center justify-end"
                //href="/CreateCorporateMembers"
                >
                  {
                    props && props.isLoadingForRenewal === true ?
                      (
                        <ButtonLoader />
                      )
                      :
                      (
                        <button
                          className="w-32 px-7 py-3 btn-sm btn-red text-xl text-white font-semibold"
                          //onClick={() => props.renewCorporateMember()}
                          disabled
                        >
                          Renew
                        </button>
                      )
                  }
                </a>
              </div>
              :
              <div className="left-btn">
                <a href="#."
                  className="flex items-center justify-end"
                //href="/CreateCorporateMembers"
                >
                  {
                    // props && props.isLoadingForRenewal === true ?
                    //   (
                    //     <ButtonLoader />
                    //   )
                    //   :
                    //   (
                    //     <button
                    //       className="w-32 px-7 py-3 btn-sm btn-red text-xl text-white font-semibold"
                    //       //onClick={() => props.renewCorporateMember()}
                    //       disabled
                    //     >
                    //       Renew New
                    //     </button>
                    //   )
                  }
                </a>
              </div>} */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CorporateMembershipSubscription;
